module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-kind"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content",
    class: {
      more: _vm.showMore
    }
  }, [(!_vm.multiple) ? [(_vm.confirmTitle) ? _vm._l((_vm.list), function(item, index) {
    return _c('rt-popconfirm', {
      key: index,
      attrs: {
        "title": _vm.confirmTitle
      },
      on: {
        "onConfirm": function($event) {
          return _vm.itemClick(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "__item",
      class: {
        active: _vm.currentItem == index
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n            " + _vm._s(item[_vm.alias.name]) + "\n          ")])])
  }) : (!_vm.confirmTitle) ? _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "__item",
      class: {
        active: _vm.currentItem == index
      },
      on: {
        "click": function($event) {
          return _vm.itemClick(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item[_vm.alias.name]) + "\n        ")])
  }) : _vm._e()] : _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "__item",
      class: {
        active: _vm.isCheck(item)
      },
      on: {
        "click": function($event) {
          return _vm.itemMultipleClick(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item[_vm.alias.name]) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.showBtn) ? _c('div', {
    staticClass: "operation"
  }, [_c('rt-button', {
    attrs: {
      "suffix-icon": _vm.suffixIcon,
      "text": ""
    },
    on: {
      "click": _vm.showMoreClick
    }
  }, [_vm._v("\n      更多\n    ")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e1f4514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/kind/rtKind.vue
// module id = 1457
// module chunks = 72